import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const TaskInput = () => {
  const { taskId = '' } = useParams();
  const decodedId = taskId ? atob(taskId) : taskId;
  const id = decodedId.replace(/\D/g, '');

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'task';

  useEffect(() => {
    if (taskId) {
      setIsEditing(true);
      fetchTaskDetails();
    }
  }, [taskId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchTaskDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.task}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching task details:', error);
    }
  };

  const taskFields = [
    { name: 'title', label: 'Task Title', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    {
      name: 'task_type', label: 'Task Type', type: 'select',
      options: [
        { value: 'Call', label: 'Call' },
        { value: 'Email', label: 'Email' },
        { value: 'Meeting', label: 'Meeting' },
        { value: 'Follow-up', label: 'Follow-up' },
        { value: 'Demo', label: 'Demo' },
        { value: 'Proposal', label: 'Proposal' },
        { value: 'Research', label: 'Research' },
        { value: 'Admin', label: 'Admin' },
        { value: 'Other', label: 'Other' },
      ],
    },
    {
      name: 'priority', label: 'Priority', type: 'select',
      options: [
        { value: 'Low', label: 'Low' },
        { value: 'Medium', label: 'Medium' },
        { value: 'High', label: 'High' },
        { value: 'Urgent', label: 'Urgent' },
      ],
    },
    { name: 'start_date', label: 'Start Date', type: 'date', dateConstraint: 'future' },
    { name: 'due_date', label: 'Due Date', type: 'date', dateConstraint: 'future' },
    { name: 'completion_date', label: 'Completion Date', type: 'date', dateConstraint: 'past' },
    {
      name: 'status', label: 'Status', type: 'select',
      options: [
        { value: 'To Do', label: 'To Do' },
        { value: 'In Progress', label: 'In Progress' },
        { value: 'Completed', label: 'Completed' },
        { value: 'On Hold', label: 'On Hold' },
        { value: 'Cancelled', label: 'Cancelled' },
      ],
    },
    {
      name: 'assigned_to', label: 'Assigned To', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (user) => user.username,
    },
    {
      name: 'related_lead', label: 'Related Lead', type: 'async-select',
      endpoint: API_ROUTES.lead,
      getOptionLabel: (lead) => lead.title || (lead.contact_data && lead.contact_data.name) || `Lead #${lead.id}`,
    },
    {
      name: 'related_opportunity', label: 'Related Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (opp) => opp.opportunity_name,
    },
    { name: 'notes', label: 'Notes', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Task Details' : 'Create Task'}</h1>
      <FormComponent fields={taskFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default TaskInput;
